// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"7d42d46d","334":"d392b0fd","530":"10ee80f7","557":"43160ea2","858":"4ef8c3d8","896":"61fed167"}[chunkId] + ".chunk.js";
};